<script lang="ts">
import { IntentionI3pService } from '~/services/intentions.i3p.service'
import IntentionsI3p from '~/components/I3pComponent/intentions/IntentionsI3p.vue'
import { BaseRoutesEnum } from '~/enum/BaseRoutes.enum'
import { useConfigStore } from '~/store'

export default {
    name: 'MesIntentions',
    components: {
        IntentionsI3p,
    },
    setup() {
        useHead({
            title: 'Mes intentions',
            meta: [
                { name: 'description', content: 'Mes intentions' },
            ],
        })
        definePageMeta({
            middleware: ['auth'],
        })
    },
    data() {
        const configStore = useConfigStore()
        const route = useRoute()
        return {
            configStore,
            route,
            baseUrl: BaseRoutesEnum.myIntentions,
            intentionI3pService: new IntentionI3pService()
                .setInitialQuery({ status: '_1_new,_2_active' })
                .setHiddenFilters(['organization_id', 'status', 'archive_status']),
        }
    },
    computed: {
        isApplicationServiceReady(): boolean {
            return !!this.configStore?.currentConfig?.app_info
        },
        isIntentionImportRoute() {
            return this.route.fullPath.includes('intentions-import')
        },
    },
    watch: {
        'route.path': {
            async handler() {
                if (!this.isIntentionImportRoute) {
                    await this.intentionI3pService.loadData(!this.route.params.k)
                }
            },
            deep: true,
            immediate: true,
        },
    },
}
</script>

<template>
    <NuxtPage v-if="isIntentionImportRoute" />
    <div v-show="!isIntentionImportRoute">
        <IntentionsI3p v-if="isApplicationServiceReady" :i3p-service="intentionI3pService" :base-url />
    </div>
</template>
